export const SET_CLASS_LIST = 'SET_CLASS_LIST';
export const ADD_TO_CLASS_LIST = 'ADD_TO_CLASS_LIST';
export const REMOVE_CLASS = 'REMOVE_CLASS';
export const RESET_CLASS_LIST = 'RESET_CLASS_LIST';
export const REMOVE_CLASS_LIST = 'REMOVE_CLASS_LIST';
export const FETCHED_CLASS_NAME = 'FETCHED_CLASS_NAME';
export const CLEAR_CLASS_NAME = 'CLEAR_CLASS_NAME';


// WEBPACK FOOTER //
// ./src/store/modules/class-page/mutations.js